import { lazy } from 'react'

/**
 * slug -> lazily-loaded tool component.
 *
 * Import specifiers must be string literals so Rollup can statically analyse them
 * and emit a chunk per tool. An explicit map (rather than import.meta.glob) makes a
 * missing component a visible diff and lets scripts/check-registry.mjs verify it.
 */
export const TOOL_COMPONENTS = {
  'json-flattener': lazy(() => import('../pages/tools/JSONFlattener.jsx')),
  'env-json-converter': lazy(() => import('../pages/tools/EnvJSONConverter.jsx')),
  'jsonl-viewer': lazy(() => import('../pages/tools/JSONLViewer.jsx')),
  'json-to-typescript': lazy(() => import('../pages/tools/JSONToTypeScript.jsx')),
  'json-schema-generator': lazy(() => import('../pages/tools/JSONSchemaGenerator.jsx')),
  'query-string-json-converter': lazy(() => import('../pages/tools/QueryStringJSONConverter.jsx')),
  'slug-generator': lazy(() => import('../pages/tools/SlugGenerator.jsx')),
  'uuid-generator': lazy(() => import('../pages/tools/UUIDGenerator.jsx')),
  'json-viewer': lazy(() => import('../pages/tools/JSONViewer.jsx')),
  'python-dict-converter': lazy(() => import('../pages/tools/PythonDictConverter.jsx')),
  'base64-encoder-decoder': lazy(() => import('../pages/tools/Base64Tool.jsx')),
  'base64-to-image': lazy(() => import('../pages/tools/Base64ToImage.jsx')),
  'image-to-base64': lazy(() => import('../pages/tools/ImageToBase64.jsx')),
  'hash-generator': lazy(() => import('../pages/tools/HashGenerator.jsx')),
  'qr-code-generator': lazy(() => import('../pages/tools/QRCodeGenerator.jsx')),
  'jwt-decoder': lazy(() => import('../pages/tools/JWTDecoder.jsx')),
  'markdown-preview': lazy(() => import('../pages/tools/MarkdownPreview.jsx')),
  'regex-tester': lazy(() => import('../pages/tools/RegexTester.jsx')),
  'cron-expression-builder': lazy(() => import('../pages/tools/CronExpressionBuilder.jsx')),
  'sql-formatter': lazy(() => import('../pages/tools/SQLFormatter.jsx')),
  'csv-json-converter': lazy(() => import('../pages/tools/CSVJSONConverter.jsx')),
  'pdf-to-text': lazy(() => import('../pages/tools/PDFToText.jsx')),
  'pdf-merger': lazy(() => import('../pages/tools/PDFMerger.jsx')),
  'pdf-splitter': lazy(() => import('../pages/tools/PDFSplitter.jsx')),
  'image-converter': lazy(() => import('../pages/tools/ImageConverter.jsx')),
  'image-resizer': lazy(() => import('../pages/tools/ImageResizer.jsx')),
  'image-compressor': lazy(() => import('../pages/tools/ImageCompressor.jsx')),
  'compare-text': lazy(() => import('../pages/tools/CompareText.jsx')),
  'compare-json': lazy(() => import('../pages/tools/CompareJSON.jsx')),
  'word-counter': lazy(() => import('../pages/tools/WordCounter.jsx')),
  'case-converter': lazy(() => import('../pages/tools/CaseConverter.jsx')),
  'lorem-ipsum': lazy(() => import('../pages/tools/LoremIpsum.jsx')),
  'color-picker': lazy(() => import('../pages/tools/ColorPicker.jsx')),
  'timestamp-converter': lazy(() => import('../pages/tools/TimestampConverter.jsx')),
  'world-clock': lazy(() => import('../pages/tools/WorldClock.jsx')),
  'timezone-meeting-planner': lazy(() => import('../pages/tools/TimezoneMeetingPlanner.jsx')),
  'unit-converter': lazy(() => import('../pages/tools/UnitConverter.jsx')),
  'currency-converter': lazy(() => import('../pages/tools/CurrencyConverter.jsx')),
  'url-encoder-decoder': lazy(() => import('../pages/tools/URLEncoderDecoder.jsx')),
  'what-is-my-ip': lazy(() => import('../pages/tools/WhatIsMyIP.jsx')),
  'ip-from-url': lazy(() => import('../pages/tools/IPFromUrl.jsx')),
  'ip-to-location': lazy(() => import('../pages/tools/IPToLocation.jsx')),
  'percentage-calculator': lazy(() => import('../pages/tools/PercentageCalculator.jsx')),
  'random-number-generator': lazy(() => import('../pages/tools/RandomNumberGenerator.jsx')),
  'password-generator': lazy(() => import('../pages/tools/PasswordGenerator.jsx')),
  'bmi-calculator': lazy(() => import('../pages/tools/BmiCalculator.jsx')),
  'age-calculator': lazy(() => import('../pages/tools/AgeCalculator.jsx')),
  'tip-calculator': lazy(() => import('../pages/tools/TipCalculator.jsx')),
  'loan-emi-calculator': lazy(() => import('../pages/tools/LoanEmiCalculator.jsx')),
  'compound-interest-calculator': lazy(() => import('../pages/tools/CompoundInterestCalculator.jsx')),
  'discount-calculator': lazy(() => import('../pages/tools/DiscountCalculator.jsx')),
  'scientific-calculator': lazy(() => import('../pages/tools/ScientificCalculator.jsx')),
  'average-calculator': lazy(() => import('../pages/tools/AverageCalculator.jsx')),
  'area-volume-calculator': lazy(() => import('../pages/tools/AreaVolumeCalculator.jsx')),
  'number-base-converter': lazy(() => import('../pages/tools/NumberBaseConverter.jsx')),
  'fraction-calculator': lazy(() => import('../pages/tools/FractionCalculator.jsx')),
  'speed-distance-time-calculator': lazy(() => import('../pages/tools/SpeedDistanceTimeCalculator.jsx')),
  'gcd-lcm-calculator': lazy(() => import('../pages/tools/GcdLcmCalculator.jsx')),
  'prime-number-checker': lazy(() => import('../pages/tools/PrimeNumberChecker.jsx')),
  'quadratic-equation-solver': lazy(() => import('../pages/tools/QuadraticEquationSolver.jsx')),
  'periodic-table': lazy(() => import('../pages/tools/PeriodicTable.jsx')),
  'molar-mass-calculator': lazy(() => import('../pages/tools/MolarMassCalculator.jsx')),
  'physics-calculator': lazy(() => import('../pages/tools/PhysicsCalculator.jsx')),
  'ohms-law-calculator': lazy(() => import('../pages/tools/OhmsLawCalculator.jsx')),
  'gas-laws-calculator': lazy(() => import('../pages/tools/GasLawsCalculator.jsx')),
  'half-life-calculator': lazy(() => import('../pages/tools/HalfLifeCalculator.jsx')),
  'wavelength-frequency-calculator': lazy(() => import('../pages/tools/WavelengthFrequencyCalculator.jsx')),
  'density-calculator': lazy(() => import('../pages/tools/DensityCalculator.jsx')),
  'resistor-color-code': lazy(() => import('../pages/tools/ResistorColorCode.jsx')),
  'ph-calculator': lazy(() => import('../pages/tools/PhCalculator.jsx')),
  'formula-cheatsheet': lazy(() => import('../pages/tools/FormulaCheatsheet.jsx')),}
